export const MONTHS = [
    { id: 0, label: 'Январь' },
    { id: 1, label: 'Февраль' },
    { id: 2, label: 'Март' },
    { id: 3, label: 'Апрель' },
    { id: 4, label: 'Май' },
    { id: 5, label: 'Июнь' },
    { id: 6, label: 'Июль' },
    { id: 7, label: 'Август' },
    { id: 8, label: 'Сентябрь' },
    { id: 9, label: 'Октябрь' },
    { id: 10, label: 'Ноябрь' },
    { id: 11, label: 'Декабрь' }
];

export const WEEK_DAYS = [
    { id: 0, label: 'ПН' },
    { id: 1, label: 'ВТ' },
    { id: 2, label: 'СР' },
    { id: 3, label: 'ЧТ' },
    { id: 4, label: 'ПТ' },
    { id: 5, label: 'СБ' },
    { id: 6, label: 'ВС' }
];
